function PhotoGallery() {
   return (
    
      <div className="page-container">
          <h1 className="page-title">GIMA Photo Gallery</h1>

          <div className="page-content">
            <p>
            To be updated!
            </p>

          </div>
        </div>

  );
}
export default PhotoGallery;